import { BoMItemRow } from 'model/Project/BoMItemRow'
import { ProjectState } from 'store/Project/ProjectTypes'
import { applyIssuesFilter } from './IssuesFilter/applyIssuesFilter'
import {
  applyArticleIdFilter,
  applyManufacturabilityFilter,
  applyPartTypeIdFilter,
  applyResourceIdFilter,
} from './IssuesFilter/applyPartTypeIdFilter'
import { issueFilterActive } from './IssuesFilter/issueFilterActive'
import {
  articleIdFilterIsActive,
  manufacturabilityFilterEnabled,
  partTypeFilterIsActive,
  resourceIdFilterIsActive,
} from './IssuesFilter/partTypeFilterIsActive'
import { applyMaterialFilter } from './MaterialFilter/applyMaterialFilter'
import { materialFilterActive } from './MaterialFilter/materialFilterActive'
import { applyWorkingStepFilter } from './WorkingStepFilter/applyWorkingStepFilter'
import { workingStepFilterActive } from './WorkingStepFilter/workingStepFilterActive'

export const BoMItemFilter = (
  filters: Partial<ProjectState['filters']>,
  row: BoMItemRow
) => {
  let showItem = true

  if (materialFilterActive(filters.byMaterialKeywords)) {
    showItem = applyMaterialFilter(filters.byMaterialKeywords.filter, row)
    // console.log('afterMaterialFilter', showItem)
  }

  if (workingStepFilterActive(filters.byWorkingStep)) {
    showItem =
      showItem && applyWorkingStepFilter(filters.byWorkingStep.filter, row)

    // console.log('afterWorkingStepFilter', showItem)
  }

  if (issueFilterActive(filters.byIssues)) {
    showItem = showItem && applyIssuesFilter(filters.byIssues.filter, row)
  }

  if (partTypeFilterIsActive(filters.byPartTypeId)) {
    showItem =
      showItem && applyPartTypeIdFilter(filters.byPartTypeId.filter, row)
  }

  if (articleIdFilterIsActive(filters.byArticleId)) {
    showItem = showItem && applyArticleIdFilter(filters.byArticleId.filter, row)
  }

  if (resourceIdFilterIsActive(filters.byResourceId)) {
    showItem =
      showItem && applyResourceIdFilter(filters.byResourceId.filter, row)
  }

  if (manufacturabilityFilterEnabled(filters.byManufacturability)) {
    showItem =
      showItem &&
      applyManufacturabilityFilter(filters.byManufacturability.filter, row)
  }

  return showItem
}
